import { isMatch, forOwn, isObjectLike, has } from 'lodash'

export function matchesDeep(object, source) {
    let results = []
    if (isMatch(object, source)) results.push(['.'])
    innerFindRecursive(object, source, [], results)
    return results
}

function innerFindRecursive(object, source, rootPath = [], results = []) {
    forOwn(object, (value, key) => {
        if (isObjectLike(value)) {
            if (isMatch(value, source)) results.push([...rootPath, key])
            //we recurse
            innerFindRecursive(value, source, [...rootPath, key], results)
        }
    })
}

export function findDeep(object, sources) {
    let results = []
    forOwn(object, (value, key) => {
        for (const source of sources) if (key === source) results.push([key])
    })
    innerFind2Recursive(object, sources, [], results)
    return results
}

function innerFind2Recursive(object, sources, rootPath = [], results = []) {
    forOwn(object, (value, key) => {
        for (const source of sources)
            if (isObjectLike(value)) {
                if (has(value, source)) results.push([...rootPath, key, source])
            }
        if (isObjectLike(value))
            innerFind2Recursive(value, sources, [...rootPath, key], results)
    })
}
